module.exports = __webpack_public_path__ + "static/media/help-icon.2b2a512d.svg";